
export enum EventType {
    ADD_COMMENT = 'CD.EVTTY070_00000',
    MODIFY_URGENCY = 'CD.EVTTY120_00000',
    CREATE_ISSUE = 'CD.EVTTYI10_00000',
    RESOLVE_ISSUE = 'CD.EVTTYI20_00000',
    ADD_ISSUE_COMMENT = 'CD.EVTTYI30_00000',
    IN_PROGRESS_ISSUE = 'CD.EVTTYI40_00000',
    RESOLVE_TICKET = 'CD.EVTTYI50_00000',
    CLOSE_TICKET = 'CD.EVTTYI60_00000',
    ADD_NOTE = 'CD.EVTTYI70_00000'
}




// WEBPACK FOOTER //
// ./src/app/shared/enums/event-type.enum.ts